import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import GettingStarted from './pages/GettingStarted';
import QuickStart from './pages/QuickStart';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import SCA from './pages/SCA';
import SAST from './pages/SAST';
import DAST from './pages/DAST';
import SecretsDetection from './pages/SecretsDetection';
import ThreatModeling from './pages/ThreatModeling';
import SBOM from './pages/SBOM';
import APISecurity from './pages/APISecurity';
import InfrastructureSecurity from './pages/InfrastructureSecurity';
import ANAActions from './pages/ANAActions';
import Integrations from './pages/Integrations';
import Features from './pages/Features';
import UserGuide from './pages/UserGuide';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<GettingStarted />} />
          <Route path="/quickstart" element={<QuickStart />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/sca" element={<SCA />} />
          <Route path="/sast" element={<SAST />} />
          <Route path="/dast" element={<DAST />} />
          <Route path="/secrets" element={<SecretsDetection />} />
          <Route path="/threat-modeling" element={<ThreatModeling />} />
          <Route path="/sbom" element={<SBOM />} />
          <Route path="/api-security" element={<APISecurity />} />
          <Route path="/infrastructure" element={<InfrastructureSecurity />} />
          <Route path="/ana-actions" element={<ANAActions />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/features" element={<Features />} />
          <Route path="/user-guide" element={<UserGuide />} />
          <Route path="*" element={<GettingStarted />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
